<template>
  <div class="top" :style="boxStyle">
    <div
      :style="{
        ...divStyle,
        ...getStyle?.(item)
      }"
      @click="clickFn(item.fn,index)"
      :class="{active:isClick == index}"
      v-for="(item, index) in topBarDatas"
      :key="index"
    >
      <span v-if="iconShow" :style="{ backgroundImage: `url(${TopBarIcon})`, ...iconStyle, ...getIconStyle?.(item) }"></span>
      <span :style="nameStyle">{{item.name}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TopTab',
  methods:{
    clickFn(fn,index){
      this.isClick = index
      fn()
    }
  },
  props: {
    getIconStyle: Function,
    iconStyle: Object,
    getStyle: {
      type: Function,
      default: () => {}
    },
    iconShow: {
      type: Boolean,
      default: true
    },
    boxStyle: Object,
    divStyle: Object,
    defaultClickIndex: {
      type: Number,
      default: 0
    },
    nameStyle: {
      type: Object
    },
    oneFn: {
      type: Function,
      default: () => {},
    },
    twoFn: {
      type: Function,
      default: () => {},
    },
    threeFn: {
      type: Function,
      default: () => {},
    },
    topBarDatas:{
      type: Array,
      default: function(){
        return [
          {
            name:'A',
            fn: this.oneFn
          },
          {
            name:'B',
            fn: this.twoFn
          },
          {
            name:'C',
            fn: this.threeFn
          }
        ]
      }
    },
    immediately: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    topBarDatas: {
      handler(value){
        this.immediately && value[0].fn();
      }
    }
  },
  mounted() {
    this.isClick = this.defaultClickIndex;
    this.$nextTick(() => {
      this.immediately && this.topBarDatas[this.defaultClickIndex]?.fn();
    })
  },
  data() {
    return {
      isClick:0,
      TopBarIcon: require('../assets/img/TopBarIcon.png')
    }
  },
}
</script>
<style lang="less" scoped>
.top {
  z-index: 2;
  .active{
    background: #052666 !important;
  }
  div{
    float: left;
    height: 0.34rem;
    min-width: 0.88rem;
    margin-bottom: 0.15rem;
    border: 1px solid #1A3F81;
    border-radius: 0.1rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-left: 0.1rem;
    margin-right: 0.1rem;
    padding-right: 0.1rem;
    &:hover{
      background: #052666 !important;
    }
    span:first-child{
      width: 0.25rem;
      height: 0.25rem;
      margin-right: 0.16rem;
      background-size: 100% 100%;
      flex: none;
    }
    span:last-child{
      font-size: 0.16rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #02D9FD;
    }
  }
}
</style>
